<div class="user-orders-wrapper">
  <ion-segment [(ngModel)]="selectedTab">
    <ion-segment-button value="tickets">
      <ion-label>YOUR TICKETS</ion-label>
    </ion-segment-button>
    <ion-segment-button value="tables">
      <ion-label>YOUR TABLES</ion-label>
    </ion-segment-button>
  </ion-segment>

  <ng-container *ngIf="selectedTab === 'tickets'">
    <app-imp-ticket-controller></app-imp-ticket-controller>
  </ng-container>

  <ng-container *ngIf="selectedTab === 'tables'">
    <app-imp-table-controller></app-imp-table-controller>
  </ng-container>
</div>
